import { put, select, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Functions
import { functions } from "./../firebase";

//Deps
import TapaDemo from "./../lib/TapaDemo";
import * as UTIL from "./../pages/util";

//Selectors
import { getApiKey, getSiteId } from "./selectors";

function* handleFetchData(action) {
  /*

  Handle DEMO data

  */
  if (action.payload.apiKey === "demo") {
    const demoData = new TapaDemo();
    yield put({
      type: ACTIONS.INIT_DEMO,
      payload: { ...JSON.parse(JSON.stringify(demoData)) }
    });
  } else {
    // //UIDs
    const siteId = yield select(getSiteId);
    const apiKey = yield select(getApiKey);

    if (siteId && apiKey) {
      try {
        //Use callable function
        const fetchData = functions.httpsCallable("fetchData");
        const data = yield fetchData({ siteId, apiKey }).then(result => {
          return JSON.parse(result.data);
        });
        const normalizedData = UTIL.dataNormalizer(data);
        yield put({ type: ACTIONS.STORE_DATA, payload: normalizedData });
      } catch (err) {
        console.log(err);
      }
    } else {
      return null;
    }
  }
}

export function* fetchData() {
  yield takeEvery(ACTIONS.FETCH_DATA, handleFetchData);
}



// WEBPACK FOOTER //
// ./src/sagas/fetchData.js